import Dexie from "dexie";
import { IDatabaseUpgrade } from "../database-upgrade";
import { DexieIndexKeys } from "../../dexie-index-keys";

/**
 * Defines the upgrade path for version 15 of indexed DB.
 * Adds CapturedBinaryDataFragments table for storing captured binary data fragments.
 * This table will be used to store binary data fragments captured during service actions, such as photo captures and OS&D operations.
 * The existing DispatchServiceCapturedBinaryDataFragments table will continue to be used for data which already exists at the time
 * of this upgrade. This is so that this new table can point to the V2 sync API, while existing data can finish syncing using the 
 * V1 API. After a period of 14 days no data will exist in the DispatchServiceCapturedBinaryData fragments table and
 * that table will be removed. This table will then be used exclusively for captured binary data fragments.
 */
export class DatabaseUpgradeV15 implements IDatabaseUpgrade {
	/** @inheritdoc */
	public readonly Version: number = 15;

	/** @inheritdoc */
	public Upgrade(dexieInstance: Dexie): void {
		dexieInstance.version(this.Version).stores({
			CapturedBinaryDataFragments: `${DexieIndexKeys.ID}, ${DexieIndexKeys.USER_NAME}, [${DexieIndexKeys.ID}+${DexieIndexKeys.USER_NAME}+${DexieIndexKeys.CROWN_ID}]`
		});
	}
}